import { memo } from "react";
import { IClause } from "../../../interfaces";
import { ClauseDiffHighlighter } from "./ClauseDiffHighlighter";
import { ClauseKeywordHighlighter } from "./ClauseKeywordHighlighter";

export type ClauseTextRenderProps = {
  clause: IClause;
  searchText: string;
  primaryKeywords?: Array<string>;
  secondaryKeywords?: Array<string>;
  shouldRedline: boolean;
  highlightText?: string;
  shouldHighlightKeywords: boolean;
  isKeywordSearch?: boolean;
  className: string;
  hasTextOverflow?: (isOverflow: boolean) => void;
};

export const ClauseTextRender = memo((props: ClauseTextRenderProps) => {
  if (props.shouldRedline) {
    return (
      <ClauseDiffHighlighter
        key={`${props.clause.clause_id}_redlined`}
        originalText={props.searchText}
        text={props.clause.clause_text}
        improveReadability={true}
        className={props.className}
        hasTextOverflow={props.hasTextOverflow}
      />
    );
  }

  return (
    <ClauseKeywordHighlighter
      text={props.clause.clause_text}
      keywords={props.shouldHighlightKeywords || props.isKeywordSearch ? (props.primaryKeywords ?? []) : []}
      secondaryKeywords={props.secondaryKeywords ?? []}
      className={props.className}
      key={`${props.clause.clause_id}_keyword_highlight`}
      hasTextOverflow={props.hasTextOverflow}
    />
  );
});
